import {gql, useMutation} from "@apollo/client";
import SessionActionsList from "../../components/results/SessionActionsList";
import {MutationRecalculateSessionScoreArgs, MutationReanalyseSessionCompetenceResultsArgs} from "../../schema";

const query = gql`
  query PlayerResultsChallengeResultsQuery($challengeId: ID!, $userId: ID) {
    results: getChallengeResults(challengeId: $challengeId, userId: $userId) {
      sessionId
      passed
      score
      time
      usedHints
      record
      recordState
      isContentMatches
      finishedScenariosIds
      startedAt
      resultFeedback {
        text
        feedbackStatus
      }
      parametricResults {
        parameterName
        rawSum
        percentage
      }

      competenceAnalysisState
      competenceResults {
        competence
        score
        indicators {
         indicator
         isPresent
         example
        }
      }

      actionResults {
        ...SessionActionsListActionResult
      }

      initAvatarAction {
        text
        audio
      }
    }
  }

  ${SessionActionsList.fragments.actionsResults}
`;

export const challengeQuery = gql`
  query PlayerResultsChallengeQuery($challengeId: ID!) {
    challenge: getChallenge(challengeId: $challengeId) {
      id
      name
      avatar {
        name
      }
      showDetailedResults
      mode
      inputMode
      resultMessage
      displayParametricResultMode
    }

    actions: getChallengeActions(challengeId: $challengeId) {
      id
      ...SessionActionsList
    }

    additionalScenarios: getChallengeScenarios(challengeId: $challengeId) {
      id
      name
      isMain
      actions {
        id
        ...SessionActionsList
      }
    }
  }

  ${SessionActionsList.fragments.root}
`;

export const userQuery = gql`
  query UserQuery($userId: ID!) {
    user: getUser(userId: $userId) {
      id
      fullName
      email
    }
  }
`;

export const parametricDescriptionsQuery = gql`
  query GetParametricResultDescriptions($challengeId: ID!) {
    descriptions: getChallengeParametricResultDescriptions(challengeId: $challengeId) {
      id
      conditions {
        parameter {
          id
          name
        }
        competence {
          id
          name
        }
        minValue
        maxValue
      }
      message
    }
  }
`;

export function useRecalculateScoreMutation() {
  return useMutation<{success: boolean}, MutationRecalculateSessionScoreArgs>(recalculateScoreMutation);
}

export function useReanalyseSessionCompetenceMutation() {
  return useMutation<{success: boolean}, MutationReanalyseSessionCompetenceResultsArgs>(
    reanalyseSessionCompetenceMutation,
  );
}

const recalculateScoreMutation = gql`
  mutation RecalculateScoreMutation($sessionId: ID!) {
    success: recalculateSessionScore(sessionId: $sessionId)
  }
`;

const reanalyseSessionCompetenceMutation = gql`
  mutation ReanalyseSessionCompetenceResults($sessionId: ID!) {
    success: reanalyseSessionCompetenceResults(sessionId: $sessionId)
  }
`;

export default query;
